import { useContext, useMemo } from 'react';

import { CookiesContext, CookiesContextValue } from 'apps/auth/hooks/cookiesContext';
import Cookies from 'universal-cookie';

export const useCookies = (): Cookies => {
    const cookiesContext = useContext<CookiesContextValue>(CookiesContext);
    return useMemo(() => (cookiesContext ? new Cookies(cookiesContext) : new Cookies()), [cookiesContext]);
};
